import { render, staticRenderFns } from "./Letter.vue?vue&type=template&id=0f9afece&scoped=true&"
import script from "./Letter.vue?vue&type=script&lang=ts&"
export * from "./Letter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9afece",
  null
  
)

export default component.exports